import { categories } from '@/mocks/categories';

const featureCategories = categories.slice(0, 3);

const featureImages = [
  'https://readdy.ai/api/search-image?query=Close%20up%20detail%20shot%20of%20premium%20cognac%20leather%20loafers%20with%20hand%20stitched%20detailing%20placed%20on%20soft%20sage%20green%20linen%20fabric%2C%20warm%20natural%20window%20light%20creating%20gentle%20shadows%2C%20editorial%20product%20photography%20with%20rich%20texture%20and%20refined%20composition%2C%20warm%20earthy%20tones%20with%20olive%20accents%2C%20artisanal%20craftsmanship%20focus&width=800&height=960&seq=feat-shoes-v2&orientation=portrait',
  'https://readdy.ai/api/search-image?query=Warm%20terracotta%20colored%20oversized%20knit%20sweater%20draped%20elegantly%20over%20linen%20covered%20surface%2C%20soft%20diffused%20natural%20light%20from%20side%20window%2C%20editorial%20fashion%20photography%20with%20organic%20textile%20texture%20visible%2C%20warm%20earthy%20palette%20with%20subtle%20cream%20highlights%2C%20relaxed%20lifestyle%20composition%20with%20intentional%20folds&width=800&height=960&seq=feat-hoodies-v2&orientation=portrait',
  'https://readdy.ai/api/search-image?query=Soft%20dusty%20rose%20cotton%20linen%20blend%20t-shirt%20neatly%20folded%20on%20warm%20ivory%20textured%20surface%2C%20gentle%20natural%20light%20creating%20subtle%20contour%20shadows%2C%20minimalist%20product%20photography%20with%20visible%20fabric%20weave%20detail%2C%20muted%20warm%20neutral%20palette%20with%20blush%20undertones%2C%20clean%20editorial%20composition%20with%20refreshing%20simplicity&width=800&height=960&seq=feat-tshirts-v2&orientation=portrait',
];

export default function CategoryFeatureGrid() {
  return (
    <section id="categories" className="py-16 md:py-20 px-6 md:px-12 bg-background-100">
      <div className="max-w-7xl mx-auto">
        <div className="mb-10">
          <span className="text-xs font-medium tracking-widest uppercase text-secondary-600 whitespace-nowrap">Featured Categories</span>
          <h2 className="font-heading text-3xl md:text-4xl font-semibold text-foreground-950 mt-3">
            Explore Popular Picks
          </h2>
        </div>

        <div className="grid grid-cols-1 md:grid-cols-3 gap-6">
          {featureCategories.map((cat, idx) => (
            <a
              key={cat.name}
              href={cat.url}
              target="_blank"
              rel="noopener nofollow"
              className="group relative block rounded-3xl overflow-hidden aspect-[1/1.15] cursor-pointer"
            >
              <img
                src={featureImages[idx]}
                alt={`Superbuy Spreadsheet ${cat.name} category`}
                title={`Superbuy Spreadsheet - ${cat.name} Collection`}
                className="w-full h-full object-cover transition-transform duration-500 group-hover:scale-[1.04]"
              />
              <div className="absolute inset-0 bg-gradient-to-t from-foreground-900/40 via-transparent to-transparent transition-opacity duration-300 group-hover:opacity-0"></div>
              <div className="absolute inset-0 bg-background-50/0 group-hover:bg-background-50/20 transition-colors duration-300"></div>
              <div className="absolute inset-0 flex flex-col items-center justify-end pb-8 px-6">
                <h3 className="font-heading text-2xl md:text-3xl font-semibold text-background-50 mb-2 group-hover:text-foreground-900 transition-colors duration-300">
                  {cat.name}
                </h3>
                <span className="text-xs text-background-50/80 group-hover:text-foreground-700 transition-colors duration-300 whitespace-nowrap">
                  Explore Collection
                </span>
              </div>
            </a>
          ))}
        </div>
      </div>
    </section>
  );
}